import fetch from '@/plugin/axios'

// 新增
export function getAddTasks (query) {
  return fetch({
    url: '/api/common/task-config/add',
    method: 'Post',
    data: query
  })
}

// 列表
export function getTasksList (query) {
  return fetch({
    url: '/api/common/task-config/list',
    method: 'Post',
    data: query
  })
}

// 详情
export function getTasksInfo (id) {
  return fetch({
    url: `/api/common/task-config/info/${id}`,
    method: 'Get'
  })
}

// 编辑
export function getModifyTasks (id, query) {
  return fetch({
    url: `/api/common/task-config/update/${id}`,
    method: 'Post',
    data: query
  })
}
